/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { ChangeDetectorRef, Component } from '@angular/core';
import { AcrylicSurfaceService } from './acrylic-surface.service';
import { GlobalConstants } from '../constants/global-constants';

@Component({
  selector: 'sysque-acrylic-surface',
  templateUrl: './acrylic-surface.component.html',
  styleUrl: './acrylic-surface.component.scss',
  standalone: false
})
export class AcrylicSurfaceComponent {

  public isVisible = false;

  constructor(private acrylicOverlayService: AcrylicSurfaceService, private cdr: ChangeDetectorRef) {}

  public ngOnInit(): void {
    window.addEventListener(GlobalConstants.STORAGE, this.acrylicOverlayService.syncState.bind(this));
    this.acrylicOverlayService.isVisible$.subscribe(visible => {
      this.isVisible = visible;
      this.cdr.detectChanges();
    });
  }

}
